import { formatPrice, type Language } from '@posilka/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDriverStats } from '@posilka/client/api/driver';
import { useCities } from '@posilka/client/api/orders';
import { cityName } from '@posilka/client/lib/cities';
import { Segmented } from '@/components/Segmented';

type Period = 'week' | 'month' | 'total';

/** Shafyor daromadi (yetkazilganlar narxi yig'indisi) va eng ko'p yo'nalishlar. */
export function EarningsCard() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language as Language;
  const [period, setPeriod] = useState<Period>('week');
  const stats = useDriverStats();
  const cities = useCities();
  if (!stats.data || stats.data.total.count === 0) return null;
  const s = stats.data[period];
  const byId = new Map((cities.data ?? []).map((c) => [c.id, c]));
  const name = (id: string) => {
    const c = byId.get(id);
    return c ? cityName(c, lang) : '…';
  };

  return (
    <div className="card mb-4 p-5">
      <Segmented<Period>
        value={period}
        onChange={setPeriod}
        options={[
          { value: 'week', label: t('driver.stats.week') },
          { value: 'month', label: t('driver.stats.month') },
          { value: 'total', label: t('driver.stats.total') },
        ]}
      />
      <p className="mt-4 font-display text-3xl font-bold tracking-tight">
        {formatPrice(s.earned, t('common.currency'))}
      </p>
      <p className="text-sm text-hint">{t('driver.stats.deliveries', { count: s.count })}</p>
      {stats.data.topRoutes.length > 0 && (
        <div className="mt-4 space-y-1.5 border-t border-dashed border-line pt-4 text-sm">
          <p className="text-hint">{t('driver.stats.topRoutes')}</p>
          {stats.data.topRoutes.map((r) => (
            <p key={`${r.fromCityId}-${r.toCityId}`} className="flex justify-between gap-2">
              <span className="truncate">
                {name(r.fromCityId)} → {name(r.toCityId)}
              </span>
              <span className="shrink-0 text-hint">× {r.count}</span>
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
